// <<<<<<< HEAD
// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import ChooseTrainingZone from "./components/ChooseTrainingZone.jsx";
// import ConnectForm from "./components/ConnectForm.jsx";
// import OurTrainers from "./components/OurTrainers.jsx";
// import Footer from "./components/Footer.jsx";
// import MapPage from "./components/MapPage.jsx";
// import ServicesSection from "./components/ServicesSection.jsx";
// import SuccessStories from "./components/SuccessStories.jsx";
// import MainPage from "./components/MainPage.jsx";
// import LandingPage from "./components/LandingPage.jsx";
// import Loader from './components/Loader.jsx';

// import landingPageBackground from './images/LandingPageBackground.png';
// import heroImage from './images/Hero.png';
// import buttonCircle from './images/buttoncircle.png';
// import buildMuscle from './images/BuildMuscle.png';
// import privateTraining from './images/PrivateTraining.png';
// import weightlifting from './images/Weightlifting.png';
// import trainersBackground from './images/trainersbackground.png';
// import mapPageBackground from './images/MapPageBackground.png';
// import serviceBackground from './images/servicebackground.png';
// import successStoryback from './images/successStoryback.png';


// // Navigation component
// const Navigation = () => {
//   return (
//     <nav style={{ 
//       padding: '20px', 
//       backgroundColor: '#2c3e50', 
//       color: 'white',
//       borderBottom: '3px solid #3498db'
//     }}>
//       <div style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
//         <Link 
//           to="/" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white', 
//             fontWeight: 'bold',
//             fontSize: '24px'
//           }}
//         >
//           💪 GYM
//         </Link>
//         <Link 
//           to="/training-zones" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #3498db',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Training Zones
//         </Link>
//         <Link 
//           to="/trainers" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #e74c3c',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Our Trainers
//         </Link>
//         <Link 
//           to="/connect" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #39d353',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Connect
//         </Link>
//         <Link 
//           to="/footer" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #f39c12',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Footer
//         </Link>
//         <Link 
//           to="/map" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #9b59b6',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Map
//         </Link>
//         <Link 
//           to="/services" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #e67e22',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Services
//         </Link>
//         <Link 
//           to="/success-stories" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #27ae60',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Success Stories
//         </Link>
//         <Link 
//           to="/main" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #8e44ad',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Main Page
//         </Link>
//         <Link 
//           to="/landing" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #ff6b35',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Landing Page
//         </Link>
//         {/* <Link 
//           to="/hero" 
//           style={{ 
//             textDecoration: 'none', 
//             color: 'white',
//             padding: '8px 16px',
//             border: '2px solid #e91e63',
//             borderRadius: '6px',
//             transition: 'all 0.3s'
//           }}
//         >
//           Hero Section
//         </Link> */}
//       </div>
//     </nav>
//   );
// };

// // Home page component
// const HomePage = () => {
//   return (
//     <div style={{ padding: '40px', textAlign: 'center' }}>
//       <h1>Welcome to Our Gym</h1>
//       <p>Your fitness journey starts here!</p>
//       <Link 
//         to="/training-zones"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#3498db',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px',
//           marginRight: '15px'
//         }}
//       >
//         Choose Training Zone
//       </Link>
//       <Link 
//         to="/trainers"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#e74c3c',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px',
//           marginRight: '15px'
//         }}
//       >
//         Our Trainers
//       </Link>
//       <Link 
//         to="/connect"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#39d353',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px',
//           marginRight: '15px'
//         }}
//       >
//         Connect With Us
//       </Link>
//       <Link 
//         to="/footer"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#f39c12',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px',
//           marginRight: '15px'
//         }}
//       >
//         Footer Info
//       </Link>
//       <Link 
//         to="/map"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#9b59b6',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px',
//           marginRight: '15px'
//         }}
//       >
//         Map & Contact
//       </Link>
//       <Link 
//         to="/services"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#e67e22',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px',
//           marginRight: '15px'
//         }}
//       >
//         Our Services
//       </Link>
//       <Link 
//         to="/success-stories"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#27ae60',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px',
//           marginRight: '15px'
//         }}
//       >
//         Success Stories
//       </Link>
//       <Link 
//         to="/main"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#8e44ad',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px',
//           marginRight: '15px'
//         }}
//       >
//         Main Page
//       </Link>
//       <Link 
//         to="/landing"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#ff6b35',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px'
//         }}
//       >
//         Landing Page
//       </Link>
//       {/* <Link 
//         to="/hero"
//         style={{
//           display: 'inline-block',
//           padding: '15px 30px',
//           backgroundColor: '#e91e63',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '8px',
//           fontSize: '18px',
//           fontWeight: 'bold',
//           marginTop: '20px'
//         }}
//       >
//         Hero Section
//       </Link> */}
//     </div>
//   );
// };

// function preloadImages(imageArray) {
//   return Promise.all(
//     imageArray.map(src => {
//       return new Promise(resolve => {
//         const img = new window.Image();
//         img.src = src;
//         img.onload = resolve;
//         img.onerror = resolve;
//       });
//     })
//   );
// }
// =======
import React, { useRef, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ServicesSection from "./pages/ServicesSection";
import OurTrainers from "./pages/OurTrainers";
import ShopSection from "./pages/ShopSection";
import ChooseTrainingZone from "./pages/ChooseTrainingZone";
import PricingSection from "./pages/PricingSection";
// import ReviewsSection from "./pages/ReviewsSection"; // Commented out for future use
import SuccessStories from "./pages/SuccessStories";
import ConnectForm from "./pages/ConnectForm";
import MapPage from "./pages/MapPage";
import Footer from "./pages/Footer";
import Navbar from "./pages/Navbar";
import AllTrainersFullPage from "./pages/AllTrainersFullPage";
import ShopFullPage from "./pages/ShopFullPage";

// Main Home Page Component
function HomePage() {
  const servicesRef = useRef(null);
  const trainersRef = useRef(null);
  const shopRef = useRef(null);
  const trainingZoneRef = useRef(null);
  const connectFormRef = useRef(null);

  // State to store selected branch from pricing section
  const [selectedBranch, setSelectedBranch] = useState("Stonehousepet, Nellore");

  const scrollToServices = () => {
    if (servicesRef.current) {
      servicesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTrainers = () => {
    if (trainersRef.current) {
      trainersRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToShop = () => {
    if (shopRef.current) {
      shopRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTrainingZone = () => {
    if (trainingZoneRef.current) {
      trainingZoneRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToContact = () => {
    if (connectFormRef.current) {
      connectFormRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Handler to update selected branch from pricing section
  const handleBranchSelection = (branch) => {
    setSelectedBranch(branch);
  };

  return (
    <>
      <Navbar
        scrollToTrainers={scrollToTrainers}
        scrollToAbout={scrollToServices} // About Us will scroll to Services
        scrollToShop={scrollToShop}
        scrollToTrainingZone={scrollToTrainingZone}
        scrollToContact={scrollToContact}
      />
      <LandingPage
        scrollToServices={scrollToServices}
        scrollToTrainers={scrollToTrainers}
        scrollToShop={scrollToShop}
        scrollToTrainingZone={scrollToTrainingZone}
        scrollToContact={scrollToContact}
      />

      <div ref={servicesRef} data-section="services">
        <ServicesSection />
      </div>

      <div ref={trainersRef} data-section="trainers">
        <OurTrainers />
      </div>

      <div ref={shopRef} data-section="shop">
        <ShopSection />
      </div>

      <div ref={trainingZoneRef} data-section="training-zone">
        <ChooseTrainingZone />
      </div>

      <PricingSection
        scrollToContact={scrollToContact}
        onBranchSelect={handleBranchSelection}
      />
      {/* <ReviewsSection /> */}
      <SuccessStories />

      <div ref={connectFormRef} data-section="contact">
        <ConnectForm selectedBranch={selectedBranch} />
      </div>

      <MapPage />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/trainers" element={<AllTrainersFullPage />} />
        <Route path="/shop" element={<ShopFullPage />} />
      </Routes>
    </Router>
  );
}

export default App;
